export default __webpack_public_path__ + "resources/icons/d322-3236.webp";